import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibShape, holdItemShape } from '@bibliocommons/bc-prop-types';

import HoldActions from 'app/actions/HoldActions';
import ShelfActions from 'app/actions/ShelfActions';
import ModalActions from 'app/actions/ModalActions';
import { selectCurrentAccount } from 'app/selectors/AuthSelector';
import { selectActiveHoldsByMetadataId, selectHoldsTransactions } from 'app/selectors/HoldsSelector';
import { selectShelfTransactions } from 'app/selectors/ShelfSelector';
import accountShape from 'app/shapes/accountShape';

import CancelHoldButton from './CancelHoldButton';

export class CancelHoldButtonContainer extends React.PureComponent {
  render() {
    return <CancelHoldButton {...this.props} />;
  }
}

CancelHoldButtonContainer.propTypes = {
  bib: bibShape.isRequired,
  disabled: PropTypes.bool,
  holdItem: holdItemShape.isRequired,
  currentAccount: accountShape.isRequired,
  holdsTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  holdActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = (state, ownProps) => {
  const metadataId = ownProps.bib.get('id');
  const holds = selectActiveHoldsByMetadataId(state).get(metadataId, Immutable.List());

  return {
    holdItem: holds.size === 1 ? holds.first() : null,
    currentAccount: selectCurrentAccount(state),
    holdsTransactions: selectHoldsTransactions(state),
    shelfTransactions: selectShelfTransactions(state)
  };
};

const mapDispatchToProps = dispatch => ({
  holdActions: bindActionCreators(HoldActions, dispatch),
  shelfActions: bindActionCreators(ShelfActions, dispatch),
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CancelHoldButtonContainer);
